<template>
    <div class="faq-panel-container">
        <input :id="id" :value="id" name="faq-btn" type="radio" v-model="selectedId" v-on:click="uncheckIfChecked">
        <div class="label-wrapper">
            <label :for="id" class="header-container">
                {{title}}
            </label>
        </div>
        <div class="expand">
            <p>
                <slot></slot>
            </p>
        </div>
    </div>
</template>

<script>
    let uuid = 1;
    export default {
        name: "MainPageFAQCard",
        props: ["title"],
        data() {
            return {
                id: null,
                selectedId: null
            }
        },
        mounted() {
            this.id = this.uuid
        },
        beforeCreate() {
            this.uuid = uuid.toString();
            uuid += 1;
        },
        methods: {
            uncheckIfChecked() {
                if (this.selectedId === this.id)
                    this.selectedId = null;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../theme/theme";

    .faq-panel-container {
        display: block;
        border-radius: 0.4em;
        margin-bottom: 0.5em;
        font-weight: 300;

        label {
            font-size: 1rem;
            background: url("../../../assets/icons/expand-down.svg") no-repeat;
            background-size: 1.5rem;
            background-position-y: center;
            padding-left: 2rem;
            padding-bottom: 0.5em;
            padding-top: 0.5em;
            display: block;
        }

        input:checked ~ .label-wrapper label {
            background: url("../../../assets/icons/expand.svg") no-repeat;
            background-size: 1.5rem;
            background-position-y: center;
        }

        .label-wrapper {
            user-select: none;
        }

        .label-wrapper:hover {
            background: $back40;
        }

        input {
            display: none;
            visibility: hidden;
        }

        p {
            padding: 1em;
            font-size: 1rem;
            line-height: 1.3rem;
            text-align: justify;
        }

        input:checked ~ .expand {
            max-height: 30em;
            padding-bottom: 0.5em;
            margin-top: 0.5em;
            padding-right: 0.5em;
            transition: max-height 1.0s;
        }

        .expand {
            max-height: 0;
            overflow: hidden;
            transition: max-height 0.25s;
        }
    }
</style>